import { initializeApp, type FirebaseApp } from 'firebase/app';

let app: FirebaseApp | null = null;

/**
 * Browser Firebase config (public). Keep in sync with `public/firebase-messaging-sw.js` for background messaging.
 */
const buildConfig = () => ({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
});

/**
 * Singleton app for FCM / messaging. Returns null when env is incomplete (e.g. local stub).
 */
const getOrInitFirebaseApp = (): FirebaseApp | null => {
  if (app) return app;
  const c = buildConfig();
  if (!c.apiKey || !c.projectId || !c.appId) {
    return null;
  }
  app = initializeApp(c);
  return app;
};

export { getOrInitFirebaseApp };
